'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Preview;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonIcon = require('../../ButtonIcon');

var _ButtonIcon2 = _interopRequireDefault(_ButtonIcon);

var _Table = require('../../Table');

var _Table2 = _interopRequireDefault(_Table);

var _Column = require('../../Column');

var _Column2 = _interopRequireDefault(_Column);

var _Spinner = require('../../Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _csv = require('../icons/csv');

var _csv2 = _interopRequireDefault(_csv);

var _trash = require('../icons/trash');

var _trash2 = _interopRequireDefault(_trash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function PreviewTable(props) {
  var columns = props.columns,
      data = props.data,
      isLoading = props.isLoading;

  if (isLoading) {
    return _react2["default"].createElement('div', {
      className: 'rainbow-import-records-flow_step-two-spinner-container'
    }, _react2["default"].createElement(_Spinner2["default"], null));
  }

  return _react2["default"].createElement(_Table2["default"], {
    className: 'rainbow-import-records-flow_table',
    keyField: 'id',
    data: data
  }, columns.map(function (col) {
    return _react2["default"].createElement(_Column2["default"], {
      key: col,
      header: col,
      field: col
    });
  }));
}

PreviewTable.propTypes = {
  columns: _propTypes2["default"].array.isRequired,
  data: _propTypes2["default"].array.isRequired,
  isLoading: _propTypes2["default"].bool.isRequired
};

function Preview(props) {
  var fileName = props.fileName,
      fileType = props.fileType,
      columns = props.columns,
      data = props.data,
      isLoading = props.isLoading,
      onRemoveFile = props.onRemoveFile;
  var previewData = data.slice(0, 5);
  return _react2["default"].createElement('div', null, _react2["default"].createElement('div', {
    className: 'rainbow-import-records-flow_step-two-file-card'
  }, _react2["default"].createElement(_csv2["default"], null), _react2["default"].createElement('div', {
    className: 'rainbow-import-records-flow_step-two-file-card-content'
  }, _react2["default"].createElement('h1', {
    title: fileName,
    className: 'rainbow-import-records-flow_step-two-file-card-title'
  }, fileName), _react2["default"].createElement('h2', {
    className: 'rainbow-import-records-flow_step-two-file-card-description'
  }, fileType)), _react2["default"].createElement(_ButtonIcon2["default"], {
    className: 'rainbow-import-records-flow_step-two-file-card-delete-button-icon',
    icon: _react2["default"].createElement(_trash2["default"], {
      className: 'rainbow-import-records-flow_step-two-file-card-delete-icon'
    }),
    title: 'Remove file',
    assistiveText: 'Remove file',
    onClick: onRemoveFile
  })), _react2["default"].createElement(PreviewTable, {
    columns: columns,
    data: previewData,
    isLoading: isLoading
  }));
}

Preview.propTypes = {
  fileName: _propTypes2["default"].string,
  fileType: _propTypes2["default"].string,
  columns: _propTypes2["default"].array,
  data: _propTypes2["default"].array,
  isLoading: _propTypes2["default"].bool,
  onRemoveFile: _propTypes2["default"].func
};
Preview.defaultProps = {
  fileName: '',
  fileType: '',
  columns: [],
  data: [],
  isLoading: false,
  onRemoveFile: function onRemoveFile() {}
};